<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
    wrapClassName="ant-modal-cust-warp">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="BannerPath">
          <a-input placeholder="Please enterBannerPath" v-decorator="[ 'payBannerUrl', validatorRules.payBannerUrl]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="ChannelName">
          <a-input placeholder="Please enterChannelName" v-decorator="[ 'payChannelName', validatorRules.payChannelName]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Channel">
          <a-input placeholder="Please enterChannel" v-decorator="[ 'payChannel', validatorRules.payChannel]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Sort">
          <a-input placeholder="Please enter sort" v-decorator="[ 'sort', validatorRules.sort]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Package ID">
          <a-input placeholder="Please enterappSsid" v-decorator="[ 'appSsid', validatorRules.appSsid]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="ChannelType">
          <a-input placeholder="Please enterChannelType" v-decorator="[ 'channelType', validatorRules.channelType]" />
        </a-form-item>


        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Jump to Web Browser Open/Close">
          <a-radio-group
            v-decorator="['browserOpen', { initialValue: '0' }]">
            <a-radio value="0">Close</a-radio>
            <a-radio value="1">Enable</a-radio>
          </a-radio-group>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'

export default {
  name: "payChannelInfoModal",
  data () {
    return {
      title:"Action",
      visible: false,
      // roleDisabled: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules:{
        payBannerUrl:{
          rules: [
            { required: true, message: 'Please enterBannerPath!' },
          ]},
        payChannelName:{
          rules: [
            { required: true, message: 'Please enterChannelName!' },
          ]},
        payChannel:{
          rules: [
            { required: true, message: 'Please enterChannel!'},
          ]},
        appSsid:{
          rules: [
            { required: true, message: 'Please enterappSsid!'},
          ]},
        channelType:{
          rules: [
            { required: true, message: 'Please enterChannelType!'},
          ]},
        sort:{
          rules: [
            { required: true, message: 'Please enter sort!'},
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model,
        status: this.model.browserOpen != undefined ? '' + this.model.browserOpen : '1',
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'payBannerUrl', 'payChannelName', 'payChannel', 'sort','appSsid','channelType','browserOpen'))
      });

    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    handleOk () {
      console.log(88888)
      const that = this;
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    handleCancel () {
      this.close()
    },
  }
}
</script>

<style scoped>

</style>